import { enabledChains } from '@src/configs/chainConfig'
import { ChainId } from '@src/configs/chainInfo'

export const getBlockExplorerUrlFromChainId = (chainId: string | number) => {
    if (Number(chainId) === ChainId.Solana) {
        return 'https://solscan.io/tx'
    } else if (Number(chainId) === ChainId.Tron) {
        // tron
        return 'https://tronscan.org/#/transaction'
    } else if (Number(chainId) === ChainId.MonadTestnet) {
        return 'https://testnet.monadexplorer.com/tx'
    }
    const chainInfo = enabledChains.find(chain => +chain.id === +chainId)
    return `${chainInfo?.blockExplorers?.['default']?.url || ''}/tx`
}
